import { useRouter } from 'next/router';
import classNames from 'classnames';

import { useGetCategories } from '@api/category/categoryApis.rq';
import CatalogLink from '@com/seo/CatalogLink';
import ScrollSlider from '@com/_molecules/ScrollSlider.nd';
import { getCategorySlug } from '@utilities/catalog/matchCategory';
import { buildOtcPlpPath } from '@utilities/catalog/paths';
import { firstParam } from '@utilities/http/firstParam';
import Filter from './Filter';

const shimerItems = [1, 2];

type CategoriesProps = {
  activeCategoryCode?: string;
};

const Categories = ({ activeCategoryCode }: CategoriesProps) => {
  const { query } = useRouter();
  const { data, isLoading } = useGetCategories({ level: 1 });
  const activeSlug = firstParam(query.productListName as string | string[]);

  if (isLoading) {
    return (
      <div className="flex items-center gap-x-2 h-max sticky top-0 left-0 w-full bg-surface-primary z-50 px-4 pb-2">
        <Filter categoryCodeLevel1={activeCategoryCode} />
        {shimerItems.map((item) => (
          <div
            key={item}
            className="h-[32px] w-1/2 border border-border-primary rounded-full animate-pulse bg-surface-secondary"
          />
        ))}
      </div>
    );
  }

  return (
    <div className="flex flex-col sticky top-0 left-0 w-full bg-surface-primary z-50">
      <ScrollSlider className="flex flex-col pb-2">
        <div className="w-max min-w-full flex items-center gap-x-2 px-4">
          <Filter categoryCodeLevel1={activeCategoryCode} />
          {data?.queryResult?.map((item) => {
            const slug = getCategorySlug(item);
            const isActive =
              activeSlug === slug ||
              String(item?.categoryCodeLevel1) === String(activeCategoryCode);

            return (
              <CatalogLink
                key={item?.categoryCodeLevel1}
                href={buildOtcPlpPath(slug)}
                className={classNames(
                  'h-8 rounded-full border border-border-primary whitespace-nowrap text-nowrap w-full flex justify-center px-3 flex-nowrap text-content-primary font-normal text-sm items-center',
                  isActive &&
                    '!bg-surface-secondary !border-border-inversePrimary',
                )}
              >
                {item?.categoryNameLevel1}
              </CatalogLink>
            );
          })}
        </div>
      </ScrollSlider>
    </div>
  );
};

export default Categories;
